import { Types } from './types'

const initialState = {
    dataMoneyTransaction: {
        rows: [],
        paging: {}
    },
    dataGoldTransaction: {
        rows: [],
        paging: {}
    },
    dataListBank: {
        rows: [],
        paging: {}
    },
    dataModalGoldTransaction: {
        rows: [],
        paging: {}
    },
    dataWithdrawMoneyTransaction: {
        rows: [],
        paging: {}
    },
    dataRequestClaim: {
        rows: [],
        paging: {}
    },
    dataBankConfig: {
        rows: [],
        paging: {}
    },
    dataAllBank: [],
    dataListTranferGold: {
        rows: [],
        paging: {}
    },
    dataTransactionBuySellGold: {
        rows: [],
        paging: {}
    },
    dataCommissionsAgents: {
        rows: [],
        paging: {}
    },
    dataListSendGoldToUser: {
        rows: [],
        paging: {}
    },
    dataSwapHNG: {
        rows: [],
        paging: {}
    },
    dataStakingDaily: {
        rows: [],
        paging: {}
    },
    dataSwapUSD: {
        rows: [],
        paging: {}
    },
    dataSwapXAU: {
        rows: [],
        paging: {}
    },
    dataSwapTON: {
        rows: [],
        paging: {}
    },
    dataWithdrawUSDT: {
        rows: [],
        paging: {}
    },
    dataDepositUSDT: {
        rows: [],
        paging: {}
    },
    dataSwapHNGTele: {
        rows: [],
        paging: {}
    },
    dataBuyXAUTele: {
        rows: [],
        paging: {}
    },
    dataSellXAUTele: {
        rows: [],
        paging: {}
    },
}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_COMMISSIONS_AGENTS:
            return {
                ...newState,
                dataCommissionsAgents: action.payload
            }
        case Types.SAVE_LIST_WITHDRAW_USDT:
            return {
                ...newState,
                dataWithdrawUSDT: action.payload
            }
        case Types.SAVE_LIST_DEPOSIT_USDT:
            return {
                ...newState,
                dataDepositUSDT: action.payload
            }
        case Types.SAVE_LIST_MONEY_TRANSACTION:
            return {
                ...newState,
                dataMoneyTransaction: action.payload
            }
        case Types.SAVE_LIST_BANK_CONFIG:
            return {
                ...newState,
                dataBankConfig: action.payload
            }
        case Types.SAVE_ALL_BANK:
            return {
                ...newState,
                dataAllBank: action.payload
            }
        case Types.SAVE_LIST_WITHDRAW_MONEY_TRANSACTION:
            return {
                ...newState,
                dataWithdrawMoneyTransaction: action.payload
            }
        case Types.SAVE_LIST_GOLD_TRANSACTION:
            return {
                ...newState,
                dataGoldTransaction: action.payload
            }
        case Types.SAVE_LIST_BANK_TRANSACTION:
            return {
                ...newState,
                dataListBank: action.payload
            }
        case Types.SAVE_LIST_MODAL_GOLD_TRANSACTION:
            return {
                ...newState,
                dataModalGoldTransaction: action.payload
            }
        case Types.SAVE_LIST_TRANSACTION_BUY_SELL_GOLD:
            return {
                ...newState,
                dataTransactionBuySellGold: action.payload
            }
        case Types.SAVE_LIST_TRANFER_GOLD:
            return {
                ...newState,
                dataListTranferGold: action.payload
            }
        case Types.SAVE_LIST_SEND_GOLD:
            return {
                ...newState,
                dataListSendGoldToUser: action.payload
            }
        case Types.SAVE_LIST_SWAP_HNG:
            return {
                ...newState,
                dataSwapHNG: action.payload
            }
        case Types.SAVE_LIST_STAKING_DAILY:
            return {
                ...newState,
                dataStakingDaily: action.payload
            }
        case Types.SAVE_LIST_REQUEST_CLAIM:
            return {
                ...newState,
                dataRequestClaim: action.payload
            }
        case Types.SAVE_LIST_SWAP_USD:
            return {
                ...newState,
                dataSwapUSD: action.payload
            }
        case Types.SAVE_LIST_SWAP_XAU:
            return {
                ...newState,
                dataSwapXAU: action.payload
            }
        case Types.SAVE_LIST_SWAP_TON:
            return {
                ...newState,
                dataSwapTON: action.payload
            }
        case Types.SAVE_LIST_SWAP_HNG_TELE:
            return {
                ...newState,
                dataSwapHNGTele: action.payload
            }
        case Types.SAVE_LIST_BUY_XAU_TELE:
            return {
                ...newState,
                dataBuyXAUTele: action.payload
            }
        case Types.SAVE_LIST_SELL_XAU_TELE:
            return {
                ...newState,
                dataSellXAUTele: action.payload
            }
        default:
            return { ...newState }
    }
}
export default reducer
